import { render, staticRenderFns } from "./ContractViewObservationCreate.vue?vue&type=template&id=9a25564a&scoped=true&"
import script from "./ContractViewObservationCreate.vue?vue&type=script&lang=js&"
export * from "./ContractViewObservationCreate.vue?vue&type=script&lang=js&"
import style0 from "./ContractViewObservationCreate.vue?vue&type=style&index=0&id=9a25564a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a25564a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VSelect,
  VSpacer,
  VTextarea,
})
